import virtualPath from "meta/utils/virtualPath";
import { setDockedTabActive } from "../features/slices/rootSlice";
import { openContentUrl } from "./contentTabActions";
const notificationCenterPage = "NotificationCenter.aspx";
const notificationCenterPagePath = `${virtualPath}/NotificationCenter/${notificationCenterPage}`;
const autoFocusKey = "autoFocusOnLoad";
export const openNotifications = (autoFocusOnLoad = false) => (dispatch, getState) => {
    const { tabs } = getState().root;
    const notificationCenterTab = Object.keys(tabs).find((key) => tabs[key].url?.includes(notificationCenterPage));
    const tabExists = Boolean(notificationCenterTab);
    let url = notificationCenterPagePath;
    const search = new URLSearchParams();
    if (autoFocusOnLoad) {
        search.append(autoFocusKey, "true");
    }
    url += `?${search}`;
    if (!tabExists) {
        dispatch(openContentUrl(url, "Notifications", undefined, true, true, undefined, "clamp(420px, 25%, 666px)"));
    }
    else {
        dispatch(setDockedTabActive(notificationCenterTab));
    }
};
